module.exports = __webpack_public_path__ + "img/20.9e561e96.jpg";